<div class="p-inputgroup  wrap-chips" *ngIf="formPlycaGroup">
  <ng-container [formGroup]="formPlycaGroup" *ngIf="editable; else nonEditable">
    <p-chips [ngModel]="chipElements" class="plForm-element" (onFocus)="manageFocus($event)" (onAdd)="addMail($event)"
      (onRemove)="onAgentRemove($event)" (onChipClick)="onAgentClick($event)" [addOnTab]="true" [allowDuplicate]="false"
      [field]="'name'" inputId="to" formControlName="receivers">
    </p-chips>
    <button class="btn btn-outline-secondary EDITABLE integrado-multi" aria-expanded="false" appNoDblClick
      pTooltip="{{ 'General.search.company' | translate}}" tooltipPosition="top" (click)="searchCompany()"
      id="searchCompanyBtn" type="button">
      <i class="fas fa-industry" aria-hidden="true"></i>
    </button>
    <button class="btn btn-outline-secondary EDITABLE integrado-multi" *ngIf="isMailChannel()" aria-expanded="false"
      appNoDblClick pTooltip="{{ 'General.search.text' | translate}}" tooltipPosition="top" (click)="searchPerson()"
      type="button">
      <i class="fas fa-user" aria-hidden="true"></i>
    </button>
    <button class="btn btn-outline-secondary EDITABLE integrado-multi" *ngIf="!isMailChannel()" aria-expanded="false"
      appNoDblClick pTooltip="{{'Communications.detail.to.searchAgent' | translate}}" tooltipPosition="top"
      (click)="searchAgent()" type="button">
      <i class="fas fa-user" aria-hidden="true"></i>
    </button>
  </ng-container>
</div>
<ng-template #nonEditable>
  <div [formGroup]="formPlycaGroup" class="col-12 pr-0">
    <input id="receivers" type="text" [ngModel]="getAgentListDescription(model.dto.receivers)" pInputText
      class="w-100 plForm-element NOEDITABLE" [attr.disabled]="'disabled'" formControlName="receivers" />
  </div>
</ng-template>